import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

// 💥 Extended color palette — neon, glassy, gradient-style blends
const colors = [
  "rgba(59,130,246,0.4)",    // blue
  "rgba(16,185,129,0.4)",    // green
  "rgba(244,114,182,0.4)",   // pink
  "rgba(234,179,8,0.4)",     // yellow
  "rgba(239,68,68,0.4)",     // red
  "rgba(168,85,247,0.4)",    // purple
  "rgba(14,165,233,0.4)",    // sky blue
  "rgba(245,158,11,0.4)",    // amber
  "rgba(192,38,211,0.4)",    // fuchsia
  "rgba(99,102,241,0.4)",    // indigo
  "rgba(34,197,94,0.4)",     // emerald
  "rgba(250,204,21,0.4)",    // gold
  "rgba(253,164,175,0.4)",   // rose
  "rgba(125,211,252,0.4)",   // light blue
  "rgba(74,222,128,0.4)",    // lime
  "rgba(147,197,253,0.4)",   // pastel blue
  "rgba(221,214,254,0.4)",   // lavender
  "rgba(251,191,36,0.4)",    // golden yellow
  "rgba(251,113,133,0.4)",   // coral pink
  "rgba(186,230,253,0.4)",   // ice blue
  "rgba(244,63,94,0.4)",     // rose red
  "rgba(34,211,238,0.4)",    // cyan
  "rgba(94,234,212,0.4)",    // teal
  "rgba(251,146,60,0.4)",    // orange
];

const GlobalRippleEffect = () => {
  const [ripples, setRipples] = useState([]);

  useEffect(() => {
    const handleClick = (e) => {
      const x = e.clientX;
      const y = e.clientY;

      // 🎲 Randomize parameters for each ripple
      const color = colors[Math.floor(Math.random() * colors.length)];
      const size = 10 + Math.random() * 140; // 60–200px
      const blur = Math.random() * 6; // –6px blur
      const duration = 0.5 + Math.random() * 0.7; // 0.5–1.2s
      const scaleEnd = 2 + Math.random() * 3.5; // 2–5.5x scale
      const border = Math.random() < 0.3 ? "2px solid rgba(255,255,255,0.2)" : "none"; // occasional soft ring

      const newRipple = { id: Date.now(), x, y, color, size, blur, duration, scaleEnd, border };
      setRipples((prev) => [...prev, newRipple]);

      setTimeout(() => {
        setRipples((prev) => prev.filter((r) => r.id !== newRipple.id));
      }, duration * 500);
    };

    window.addEventListener("click", handleClick);
    return () => document.body.removeEventListener("click", handleClick);
  }, []);

  return (
    <div className="fixed inset-0 pointer-events-none z-[50] overflow-hidden">
      <AnimatePresence>
        {ripples.map((ripple) => (
          <motion.div
            key={ripple.id}
            initial={{ scale: 0, opacity: 0.8 }}
            animate={{
              scale: [0, ripple.scaleEnd, ripple.scaleEnd + 0.4],
              opacity: [0.8, 0.5, 0],
              filter: [
                `blur(0px)`,
                `blur(${ripple.blur}px)`,
                `blur(${ripple.blur * 2}px)`,
              ],
            }}
            exit={{ opacity: 0 }}
            transition={{ duration: ripple.duration, ease: "easeOut" }}
            className="absolute rounded-full"
            style={{
              width: `${ripple.size}px`,
              height: `${ripple.size}px`,
              top: ripple.y,
              left: ripple.x,
              background: ripple.color,
              border: ripple.border,
              transform: "translate(-50%, -50%)",
              mixBlendMode: "screen", // ✨ makes overlapping colors blend beautifully
            }}
          />
        ))}
      </AnimatePresence>
    </div>
  );
};

export default GlobalRippleEffect;
